module.exports = __webpack_public_path__ + "static/northern-ireland-2d9b6972ee0c0439570b9cc1b67589e7.svg";